import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
export default function HideLogRow(props) {
    const { row } = props;
    return (
        <TableRow key={row.index}>
            <TableCell
                component="th"
                scope="row"
                style={{ width: 200, minwidth: 150 }}
            >
                {row.itemName}
            </TableCell>
            <TableCell style={{ minwidth: 150 }} align="left">
                {row.hideDate}
            </TableCell>
            <TableCell style={{ minwidth: 150 }} align="left">
                {row.hideEmail}
            </TableCell>
            <TableCell style={{ minwidth: 150 }} align="left">
                {row.unhideDate}
            </TableCell>
            <TableCell style={{ minwidth: 150 }} align="left">
                {row.unhideEmail}
            </TableCell>
        </TableRow>
    );
}
